import axios from 'axios';
import API from '../api';

export const PackageTagsModule = {
  state: {
    error: '',
    errored: false,
    package_tags: [],
    requesting: false
  },

  actions: {
    getPackageTags ({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        commit('PACKAGE_TAG_REQ_STARTED');
        let url = `${ API.BASE_URL }${ API.PACKAGETAGS }`;
        if (payload && payload.package_id) {
          url = `${ url }?package_id=${ payload.package_id }`;
        }
        return axios
          .get(url, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit('PACKAGE_TAG_GET_SUCCESS', response.data);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit('PACKAGE_TAG_REQ_FAILED', error);
            reject(error);
          });
      });
    },

    createPackageTag ({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        commit('PACKAGE_TAG_REQ_STARTED');
        return axios
          .post(`${ API.BASE_URL }${ API.PACKAGETAGS }`, payload, API.RequestHeaders())
          .then(response => {
            if (response.status === 201) {
              commit('PACKAGE_TAG_CREATE_SUCCESS', response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit('PACKAGE_TAG_REQ_FAILED', error);
            reject(error);
          });
      });
    },

    updatePackageTag ({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        const id = payload.id;
        delete payload.id;
        commit('PACKAGE_TAG_REQ_STARTED');
        return axios
          .put(`${ API.BASE_URL }${ API.PACKAGETAGS }/${ id }`, payload, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit('PACKAGE_TAG_UPDATE_SUCCESS', response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit('PACKAGE_TAG_REQ_FAILED', error);
            reject(error);
          });
      });
    },

    deletePackageTag ({ commit }, id) {
      return new Promise(async (resolve, reject) => {
        commit('PACKAGE_TAG_REQ_STARTED');
        return axios
          .delete(`${ API.BASE_URL }${ API.PACKAGETAGS }/${ id }`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit('PACKAGE_TAG_DELETE_SUCCESS', id);
              resolve();
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit('PACKAGE_TAG_REQ_FAILED', error);
            reject(error);
          });
      });
    }
  },

  mutations: {
    PACKAGE_TAG_REQ_STARTED (state) {
      state.requesting = true;
    },

    PACKAGE_TAG_REQ_FAILED (state, error) {
      state.requesting = false;
      state.errored = true;
      state.error = error.message;
    },

    PACKAGE_TAG_GET_SUCCESS (state, payload) {
      state.package_tags = payload;
      state.requesting = false;
    },

    PACKAGE_TAG_CREATE_SUCCESS (state, payload) {
      state.package_tags.push(payload);
      state.requesting = false;
    },

    PACKAGE_TAG_UPDATE_SUCCESS (state, payload) {
      const index = state.package_tags
        .map(_package_tag => _package_tag.id)
        .indexOf(payload.id);

      state.package_tags[index] = {
        ...state.package_tags[index],
        ...payload
      };
      state.requesting = false;
    },

    PACKAGE_TAG_DELETE_SUCCESS (state, id) {
      const deleted = state.package_tags
        .find(_package_tag => _package_tag.id === id);

      const index = state.package_tags.indexOf(deleted);
      state.package_tags.splice(index, 1);
      state.requesting = false;
    }
  }
};